// Main class
export default class Partial {
    constructor () {
        // Getting constructor name.
        // This is the custom component name created.
        let componentName = this.constructor.name

        // Creating a valid custom element name.
        // In the future we'll probably need to use some validator.
        // Sindre Sorhus' validate-element-name is a good option:
        // https://github.com/sindresorhus/validate-element-name
        let elementName = componentName.split(/(?=[A-Z])/).map((s) => s.toLowerCase()).join('-')

        // Definig the custom elemement.
        // This is a very basic implementation.
        // In the future we need to include a polyfill and validade
        // if it's the best approach.
        window.customElements.define(elementName, class PartialBase extends HTMLElement {
            constructor() {
              super();
              
              // TODO: Implement shadow DOM
              // Below is an example on how to use it.

            //   var shadow = this.attachShadow({mode: 'open'});
              // Create a standard img element and set it's attributes.
            //   var div = document.createElement('div');
            //   div.innerHTML = 'DIV';
          
              // Add the image to the shadow root.
            //   shadow.appendChild(div);
          
              // Add an event listener to the image.
            //   div.addEventListener('click', () => {
            //     console.log('DIV CLICK')
            //   });
            }

            // TODO: Implement observer
            // Perhaps this is a good approach, but I'm not sure yet.
            // Example below:
            /* static get observedAttributes() {return ['name']; }
            connectedCallback() {
                console.log('connected')
            }

            attributeChangedCallback(attr, oldValue, newValue) {
                console.log(newValue)
            }*/
        });
    }

    // Exposing the render method statically.
    // E.g: You can use `Partial.render`.
    // The bad thing about it is we don't have instances control.
    // Let's try this way first, but need more investigation.
    // @params
    // - partialElement: The class extending Partial
    // - component: The component string. E.g: <my-component>
    // - node: The target DOM node where the component will be appended
    static render(partialElement, component, node = document.body, options = { mode: 'closed' }) {
        // Mapped props from the component attributes
        // E.g: <my-component foo='bar'> should map the prop `foo` with `baz` as value.
        partialElement.props = {}

        // Target element reference
        let targetElement = null

        // The @node param could be a String or a DOMNode.
        // This is the simplest way of doing it, I'm sure we can evolve
        // this for something better.
        // First, check if it is an instance of HTMLElement
        if (node instanceof HTMLElement) {
            targetElement = node
        // Check if it's a String
        } else if (typeof node === 'string') {
            targetElement = document.querySelector(`#${node}`)
            // Simple check to validate if the node target element exists
            if (targetElement === null) {
                throw new Error('Invalid HTML selector')
            }
        }

        // Creating a DOMFragment element (just in memory)
        let fragment = document.createDocumentFragment()

        // this is the customElement root node
        let rootElement = document.createElement('div')
        rootElement = rootElement.attachShadow({mode: options.mode})

        // Let the browser do the work of parsing the custom element.
        // Here we're appending the custom element inside the rootElement.
        // Again, not sure if it's the best approach. Need investigation.
        rootElement.innerHTML = component

        // Now, let's get the custom element reference.
        // Need investigation as well.
        let webComponent = rootElement.firstChild

        // Parse all custom element attributes and tranform into instance props.
        for (let i = 0, atts = webComponent.attributes, n = atts.length, arr = []; i < n; i++){
            partialElement.props[atts[i].nodeName] = atts[i].nodeValue
        }

        // the result of rendering the component
        let componentContent = partialElement.render()

        // let's apply a shadow dom to it
        let shad = webComponent.attachShadow({mode: 'open'})

        // and use the component itself as the shadow's content
        shad.innerHTML = componentContent

        // and finaly we append the element to the fragment
        fragment.appendChild(webComponent)
        // and the fragment to the target element
        targetElement.appendChild(fragment)
    }
}



// WEBPACK FOOTER //
// ./src/partial.class.js